import React from 'react'
import { useCheckoutLineItemsAdd } from '../../graphql/mutations'
import { storage } from '../../utils/index'
import { IonLoading } from '@ionic/react'

const HandleAdd = ({ children, variantId }) => {
    const [mutate, loading] = useCheckoutLineItemsAdd()

    const checkout = storage.getItem('checkout')
    const handleAdd = (e) => {
        e.preventDefault()
        mutate({
            variables: {
                lineItems: [
                    {
                        variantId,
                        quantity: 1,
                    },
                ],
                checkoutId: checkout.id,
            },
        })
    }
    return (
        <>
            <IonLoading isOpen={loading}></IonLoading>
            {React.cloneElement(children, {
                onClick: handleAdd,
            })}
        </>
    )
}

export default HandleAdd
